// get greeting based on time using moment
const getGreeting = (date: Date = new Date()) => {
  const currentHour = date.getHours();

  if (currentHour < 12) {
    return "Good Morning";
  }
  if (currentHour < 18) {
    return "Good Afternoon";
  }
  return "Good Evening";
};

export default getGreeting;
